export function addGoogleStructuredData(data) {
  const script = document.createElement('script');

  script.setAttribute('type', 'application/ld+json');

  script.textContent = JSON.stringify(data);

  document.head.appendChild(script);
}
